module.exports = __webpack_public_path__ + "img/basket.e3f78ae9.svg";